import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import { isIE } from '../../utils/browserDetection';

const useStyles = makeStyles(theme => ({
  paperRoot: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(2)
  },
  errorIcon: {
    fontSize: '2rem',
    marginRight: theme.spacing(2),
    color: theme.palette.warning.main
  }
}));

const NonSupportedBrowserMessage = () => {
  const classes = useStyles();
  const isUsingSupportedBrowser = !isIE;

  if (isUsingSupportedBrowser) {
    return null;
  }

  return (
    <Container maxWidth="sm">
      <Paper classes={{ root: classes.paperRoot }}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="row"
        >
          <ErrorIcon classes={{ root: classes.errorIcon }} />
          <div>
            You are using a browser which is not supported by iFoodPPSI.
            Supported browsers:{' '}
            <a href="https://www.google.com/intl/sv/chrome/">Chrome</a> and{' '}
            <a href="https://www.microsoft.com/sv-se/edge">Edge</a>.
          </div>
        </Box>
      </Paper>
    </Container>
  );
};

export default NonSupportedBrowserMessage;
